<button
  type="button"
  class="btn btn-primary btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1 text-nowrap"
  aria-label="Open VSI Assist"
  title="VSI Assist"
  @click="$emit('open-assistant')"
>
  <i class="bi bi-robot fs-6"></i>
  <span class="d-none d-sm-inline text-xs">VSI Assist</span>
</button>
